__turbopack_context__.v({
  "accordion": "Accordion-module-scss-module__dB7tqa__accordion",
  "accordion-header-icon": "Accordion-module-scss-module__dB7tqa__accordion-header-icon",
});
